<template>
  <!-- Figma "Scan Serial Number Modal": header band, dark camera area with a teal frame, Keep Editing.
       Same behaviour as before: the first scan fills the field and closes. -->
  <div class="p-[20px] font-roboto">
    <FxModalHeader title="Scan Serial Number" subtitle="Point the camera at the barcode on the data plate" @close="closeModal" />
    <div class="relative mt-[15px] rounded-[14px] overflow-hidden bg-[#20242C] min-h-[259px]">
      <div id="barcode-scanner" ref="barcodeScanner" class="video w-full" />
      <div class="pointer-events-none absolute inset-x-[24px] top-[24px] bottom-[52px] rounded-[6px] border-2 border-dashed border-[#17C3B2]">
        <div class="absolute left-0 right-0 top-1/2 h-[2px] bg-[#17C3B2]" />
      </div>
      <p class="pointer-events-none absolute left-0 right-0 bottom-[16px] m-0 text-center text-[13px] text-[#C9CDD4]">
        Align the barcode inside the frame
      </p>
    </div>
    <div class="flex justify-center mt-[20px]">
      <button type="button" class="inline-flex items-center justify-center min-h-[38px] px-[26px] rounded-[5px] border-1 border-[#F67280] bg-white text-[14px] font-medium text-[#F67280]"
        data-bs-dismiss="modal" @click="closeModal">
        Keep Editing
      </button>
    </div>
  </div>
</template>

<script>
import FxModalHeader from "./FxModalHeader.vue";
import Quagga from "quagga";

export default {
  components: { FxModalHeader },
  props: ["showModal"],

  data() {
    return {
      // 'qr' or 'barcode'
      result: null,
    };
  },

  watch: {
    showModal(newValue) {
      if (newValue) {
        this.initBarcodeScanner();
      } else {
        this.stopBarcodeScanner();
      }
    },
  },
  mounted() {},

  beforeUnmount() {
    this.stopBarcodeScanner();
  },
  methods: {
    onDecode(content) {
      this.result = content;
      this.$emit("scan-result", this.result);
      this.stopBarcodeScanner();
    },
    onInit(promise) {
      promise.catch((error) => {
        console.error(error);
        alert("Failed to initialize QR code scanner.");
      });
    },
    initBarcodeScanner() {
      Quagga.init(
        {
          inputStream: {
            name: "Live",
            type: "LiveStream",
            target: this.$refs.barcodeScanner,
            constraints: {
              facingMode: "environment", // or 'user' for front camera
            },
          },
          decoder: {
            readers: [
              "code_128_reader",
              "ean_reader",
              "ean_8_reader",
              "code_39_reader",
              "code_39_vin_reader",
              "codabar_reader",
              "upc_reader",
              "upc_e_reader",
              "i2of5_reader",
              "2of5_reader",
              "code_93_reader",
            ],
          },
        },
        (err) => {
          if (err) {
            console.error(err);
            return;
          }
          setTimeout(() => {
            Quagga.start();
          }, 100);
        }
      );

      Quagga.onDetected(this.onBarcodeDetected);
    },
    onBarcodeDetected(result) {
      this.result = result.codeResult.code;
      setTimeout(() => {
        this.$emit("scan-result", this.result);
        this.closeModal();
      }, 100);
      
      // Quagga.stop();
    },
    stopBarcodeScanner() {
      Quagga.offDetected(this.onBarcodeDetected);
      // Quagga.stop();
    },

    closeModal() {
      this.stopBarcodeScanner();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
#barcode-scanner {
  width: 100%;
  height: 350px;
  overflow: hidden;
}
#barcode-scanner[data-v-1dff094c] video {
  width: 100% !important;
}
/* .closebutton{
  padding: 0.2rem;
  border: 2px solid #000;
  border-radius: 50%;
  filter: invert(1);
}
.btn-close{
  font-size: 12px;
  opacity: 1;
} */
</style>
